module.exports = __webpack_public_path__ + "media/images/discord-logo-25d32792465b91b47842894d7d274ac5.png";